<template>
  <v-dialog
    v-model="dialog"
    width="600"
    @click:outside="cancel"
  >
    <v-card light>
      <v-btn
        class="float-right"
        icon
        @click="cancel"
      >
        <v-icon>close</v-icon>
      </v-btn>
      <v-card-title class="px-8 pt-12">
        {{ title }}
      </v-card-title>
      <v-card-text class="px-8">
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="userId"
                :label="textLabel"
                outlined
                :rules="rulesToUse"
                maxlength="100"
                hide-details="auto"
              />
            </v-col>
            <v-col cols="auto">
              <v-btn
                x-large
                :loading="saving"
                @click="save"
              >
                Save
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SelectDialog',
  props: {
    title: { type: String, default: '' },
    textLabel: { type: String, default: '' },
    rules: { type: Array }
  },
  data: () => ({
    dialog: false,
    saving: false,
    valid: false,
    userId: null
  }),
  computed: {
    rulesToUse() {
      if (this.rules) {
        return this.rules.concat([this.$rules.required]);
      }
      return [this.$rules.required];
    }
  },
  methods: {
    cancel() {
      this.dialog = false;
    },
    show() {
      this.dialog = true;
    },
    save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        this.$emit('save', this.userId);
      }
    }
  }
};
</script>
